const translations = {
  "en": {
    "Alert": "Alert",
    "Critical": "Critical",
    "Details": "Details",
    "Important": "Important",
    "Today": "Today"
  },
  "zh-tw": {
    "Alert": "提醒",
    "Critical": "緊急",
    "Details": "詳情",
    "Important": "重要",
    "Today": "今天"
  }
};

export default translations;
